import { useMyBusinesses } from './useMyBusinesses'

/**
 * ¿El usuario tiene al menos un negocio? Señal para gatear secciones del portal
 * que no aplican sin negocios (Facturación, Créditos y recargas): sin negocios
 * esas vistas devuelven 403, así que se ocultan del sidebar.
 *
 * Usa la MISMA fuente de verdad que "Mis negocios" (`portalMyBusinesses`) con
 * `take: 1` — solo necesitamos `totalItems`. Con `cache-first` la petición se
 * comparte/reutiliza y no repega al backend en cada navegación.
 */
export function useHasBusinesses() {
  const { totalItems, loading, error } = useMyBusinesses({ take: 1, skip: 0 })
  return {
    hasBusinesses: !error && totalItems > 0,
    loading,
  }
}
